module.exports = __webpack_public_path__ + "static/media/testimonial-author1.0dbb4bb3.png";